export function isLocalSpeaker(identity: string, me: string): boolean {
  return identity === me;
}
